import { TableActionTypes } from "store/types/table"

export const selectedRowKeys = (selectedRowKeys) => ({
    type: TableActionTypes.SET_SELECTED_ROW_KEYS,
    payload: selectedRowKeys
})

export const setSelectedRowKeys = (keys) => {
    return async (dispatch) => {
        dispatch(selectedRowKeys(keys))
    }
}